<template>
    <wire-frame-gdb>
        <template v-slot:top-main>
            <v-btn v-if="hasAtenderPerm.value" :to="{name: 'atendimentos-atende'}">Atender</v-btn>
            <v-btn v-if="hasTriagemPerm.value" :to="{name: 'atendimentos-triagem'}">Triagem</v-btn>
            <!-- <v-btn v-if="hasPainelPerm.value" :to="{name: 'atendimentos-painel-app'}" target="_blank">Painel</v-btn> -->
            <v-btn href="http://sso.undb.edu.br/atendimento/painel/" target="_blank">Painel</v-btn>
            <v-divider class="my-2"></v-divider>
        </template>
    </wire-frame-gdb>
</template>
<script setup>
import { ref, computed } from 'vue';
import  { useRouter } from 'vue-router';
const hasTriagemPerm = ref(false)
const hasAtenderPerm = ref(false)
// const hasPainelPerm = ref(false)
const router = useRouter();
hasTriagemPerm.value = computed(() => router.resolve({name: 'atendimentos-triagem'}).meta.has_perm())
hasAtenderPerm.value = computed(() => router.resolve({name: 'atendimentos-atende'}).meta.has_perm())
// hasPainelPerm.value = computed(() => router.resolve({name: 'atendimentos-painel-app'}).meta.has_perm())
</script>